<form id="register-form" [formGroup]="formGroup" (ngSubmit)="saveUser($event)" class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ "users.item.createNew" | translate }}</span>
    <button type="button" class="icon-button icon-close" (click)="goToMainView()"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">{{ "users.main.information" | translate }}</div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <app-user-picker [required]="true" formControlName="userData" placeholder="users.item.user" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input [label]="'users.item.gid' | translate" [disabled]="true" [value]="user?.gid" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input [label]="'users.item.email' | translate" [disabled]="true" [value]="user?.mail" />
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-input [label]="'users.item.department' | translate" [disabled]="true" [value]="user?.department" />
            </div>
            <div class="flex-1 card-cell">
              <sag-ui-input [label]="'users.item.departmentText' | translate" [disabled]="true" [value]="user?.departmentText" />
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-select formControlName="userRole" [label]="'users.item.roleTitle' | translate">
                @for (option of roleTypes; track option) {
                  <sag-ui-option [value]="option">
                    {{ "users.item.role." + option | translate }}
                  </sag-ui-option>
                }
              </sag-ui-select>
            </div>
            <div class="flex-1 card-cell"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
